module.exports = __webpack_public_path__ + "static/media/5750.e7615028.jpg";